import {
  IndividualWithRelations,
  IndividualRelationObject,
  CountryAlpha2
} from 'generated/graphql'
import { Signer } from 'pages/Onboarding/OnboardingRegion/UsRegion/UsRegionStepsConfigs'

export type RoleMatch = {
  individual: IndividualWithRelations['individual']
  relation: IndividualRelationObject | undefined
  index: number
}

export const findByRole = (
  individuals: IndividualWithRelations[],
  predicate: (rel: IndividualRelationObject) => boolean
): RoleMatch | null => {
  const index = individuals.findIndex(ind =>
    ind.parentRelations?.some(predicate)
  )
  if (index === -1) return null
  const match = individuals[index]
  const relation = match.parentRelations?.find(predicate)
  return { individual: match.individual, relation, index }
}

export const mapToFormIndividual = (data: RoleMatch) => ({
  individual: {
    firstName: data.individual.firstName ?? '',
    middleName: data.individual.middleName,
    lastName: data.individual.lastName ?? '',
    email: data.individual.email ?? '',
    phoneNumber: data.individual.phoneNumber ?? '',
    dateOfBirth: data.individual.dateOfBirth
      ? Number(data.individual.dateOfBirth)
      : 0,
    nationalities: (data.individual.nationalities ?? []) as CountryAlpha2[],
    ssn: data.individual.ssn ?? '',
    identificationDocumentType:
      data.individual.identificationDocumentType ?? '',
    idNumber: data.individual.idNumber ?? '',
    residentialAddress: {
      addressLine: data.individual.residentialAddress?.addressLine ?? '',
      addressLine2: data.individual.residentialAddress?.addressLine2,
      city: data.individual.residentialAddress?.city ?? '',
      state: data.individual.residentialAddress?.state,
      zip: data.individual.residentialAddress?.zip ?? '',
      countryAlpha2:
        data.individual.residentialAddress?.countryAlpha2 ?? CountryAlpha2.Us
    }
  },
  relation: { title: data.relation?.title ?? '' }
})

export const mapSignerToInput = (data: Signer) => {
  const { residentialAddress, dateOfBirth, ...individualFields } =
    data.individual
  return {
    ...individualFields,
    dateOfBirth: dateOfBirth ? String(dateOfBirth) : null,
    residentialAddress: {
      ...residentialAddress,
      countryAlpha2: CountryAlpha2.Us
    }
  }
}
